export default [
    ['IMG', '图片'],
    ['DEMO', '在线'],
]
